import styled from '@emotion/styled';

interface DividerProps {
  margin?: string; // Allows for custom margins
  color?: string; // Allows for a custom color
}

const Divider = styled.hr<DividerProps>`
  border: none;
  height: 1px;
  background-color: ${({ color }) => color || '#E1E0E7'}; // Default to #E1E0E7
  margin: ${({ margin }) => margin || '0'};
`;

export default Divider;
